import React from 'react';
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import SEO from '../../components/feature/SEO';
import SupplementationHeroSection from './components/SupplementationHeroSection';
import ProductsSection from './components/ProductsSection';
import BenefitsSection from './components/BenefitsSection';
import DonationImpactSection from './components/DonationImpactSection';
import DistributionSection from './components/DistributionSection';
import FAQSection from './components/FAQSection';
import CTASection from './components/CTASection';

const siteUrl = import.meta.env.VITE_SITE_URL || 'https://example.com';

const schema = {
  '@context': 'https://schema.org',
  '@graph': [
    {
      '@type': 'WebPage',
      '@id': `${siteUrl}/supplementation#webpage`,
      url: `${siteUrl}/supplementation`,
      name: 'Oxygen Supplementation | Capsules, Sprays & OxyKits for Families – Diatomic Life Foundation',
      description:
        'Donate to fund oxygen supplementation — capsules, sprays, and OxyKits distributed to families in need. 92% of donations go directly to oxygen products.',
      isPartOf: { '@id': `${siteUrl}/#website` },
      breadcrumb: {
        '@type': 'BreadcrumbList',
        itemListElement: [
          { '@type': 'ListItem', position: 1, name: 'Home', item: siteUrl },
          { '@type': 'ListItem', position: 2, name: 'Supplementation', item: `${siteUrl}/supplementation` },
        ],
      },
    },
    {
      '@type': 'FAQPage',
      '@id': `${siteUrl}/supplementation#faq`,
      name: 'Oxygen Supplementation FAQ – Diatomic Life Foundation',
      mainEntity: [
        {
          '@type': 'Question',
          name: 'Where do the oxygen supplementation products go?',
          acceptedAnswer: {
            '@type': 'Answer',
            text: 'All oxygen supplementation products are distributed to underserved families and communities identified through our network of healthcare partners across India.',
          },
        },
        {
          '@type': 'Question',
          name: 'How is my donation used for oxygen supplementation?',
          acceptedAnswer: {
            '@type': 'Answer',
            text: '92% of every donation goes directly to procuring and distributing oxygen supplementation products such as capsules, sprays, and OxyKits to families in need.',
          },
        },
        {
          '@type': 'Question',
          name: 'Are the oxygen supplementation products clinically tested?',
          acceptedAnswer: {
            '@type': 'Answer',
            text: 'Yes, all our oxygen supplementation products are clinically tested and meet safety standards before distribution.',
          },
        },
        {
          '@type': 'Question',
          name: 'What is an OxyKit?',
          acceptedAnswer: {
            '@type': 'Answer',
            text: 'An OxyKit is a curated package of oxygen supplementation products — including capsules and sprays — designed to support a family\'s oxygen health needs for one month.',
          },
        },
      ],
    },
  ],
};

export default function Supplementation() {
  return (
    <div className="min-h-screen bg-[#FAFAFA]">
      <SEO
        title="Oxygen Supplementation | Capsules, Sprays & OxyKits for Families – Diatomic Life Foundation"
        description="Donate to fund oxygen supplementation — capsules, sprays, and OxyKits distributed to families in need. 92% of donations go directly to oxygen products. Learn how your gift helps."
        keywords="oxygen supplementation, OxyKit, oxygen capsules, donate oxygen products, Diatomic Life Foundation"
        canonical={`${siteUrl}/supplementation`}
        schemaJson={schema}
      />
      <Header />
      <main>
        <SupplementationHeroSection />
        <ProductsSection />
        <BenefitsSection />
        <DonationImpactSection />
        <DistributionSection />
        <FAQSection />
        <CTASection />
      </main>
      <Footer />
    </div>
  );
}
